import { AppBar, styled, Toolbar } from '@mui/material';

import { IconButton } from 'components/mui/common/IconButton';

export const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'mobileApp' && prop !== 'isDrawerOpen',
})<{ isDrawerOpen: boolean; open: boolean; mobileApp: boolean }>(({ isDrawerOpen, open, mobileApp, theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.default,
  boxShadow: 'none',
  paddingLeft: mobileApp ? 0 : open ? '320px' : '72px',
  paddingRight: isDrawerOpen ? '270px' : 0,
  transition: 'all 0.3s ease',
}));

export const ActionsWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const StyledToolbar = styled(Toolbar)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
}));

export const SearchWrapper = styled('div')(({ theme }) => ({
  width: '24rem',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const MenuButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));
